/**
 * US PDP — genuine Judge.me reviews without the JM app embed.
 * Fetches SSR widget HTML, extracts rating/author/body, renders our own cards
 * (no avatars, spinners, or photo placeholders).
 */
(function () {
  if (window.__SkPdpUsReviews) return;
  window.__SkPdpUsReviews = true;

  var CACHE_PREFIX = 'sk_pdp_us_reviews_v3_';
  var CACHE_MS = 6 * 60 * 60 * 1000;
  var MAX_REVIEWS = 3;

  function cacheKey(shop, productId) {
    return CACHE_PREFIX + shop + '_' + productId;
  }

  function readCache(shop, productId) {
    try {
      var raw = localStorage.getItem(cacheKey(shop, productId));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.html || !parsed.ts) return null;
      if (Date.now() - parsed.ts > CACHE_MS) return null;
      return parsed.html;
    } catch (e) {
      return null;
    }
  }

  function writeCache(shop, productId, html) {
    try {
      localStorage.setItem(cacheKey(shop, productId), JSON.stringify({ ts: Date.now(), html: html }));
    } catch (e) {}
  }

  function textOf(el) {
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function starsFromRating(el) {
    if (!el) return 5;
    var score = parseFloat(el.getAttribute('data-score') || '');
    if (!isNaN(score) && score > 0) return Math.min(5, Math.round(score));
    var ons = el.querySelectorAll('.jdgm-star.jdgm--on').length;
    return ons > 0 ? ons : 5;
  }

  function starString(count) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += i <= count ? '★' : '☆';
    return out;
  }

  function extractReviews(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var nodes = wrap.querySelectorAll(
      '.jdgm-rev-widg__reviews > .jdgm-rev, .jdgm-ssr-reviews__list > .jdgm-rev, .jdgm-revs > .jdgm-rev'
    );
    if (!nodes.length) nodes = wrap.querySelectorAll('.jdgm-rev');

    var reviews = [];
    nodes.forEach(function (node) {
      if (reviews.length >= MAX_REVIEWS) return;
      var author = textOf(node.querySelector('.jdgm-rev__author'));
      var bodyEl = node.querySelector('.jdgm-rev__body');
      var body = textOf(bodyEl);
      if (!body) return;
      var title = textOf(node.querySelector('.jdgm-rev__title'));
      var location = textOf(node.querySelector('.jdgm-rev__location'));
      if (location) {
        location = location.replace(/^\(|\)$/g, '').trim();
      }
      reviews.push({
        rating: starsFromRating(node.querySelector('.jdgm-rev__rating')),
        author: author,
        location: location,
        title: title,
        body: body
      });
    });
    return reviews;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCards(reviews) {
    if (!reviews.length) return '';
    var html = '<ul class="pdp-us-reviews__list" role="list">';
    reviews.forEach(function (rev) {
      html += '<li class="pdp-us-reviews__card">';
      html +=
        '<div class="pdp-us-reviews__card-top">' +
        '<span class="pdp-us-reviews__card-stars" aria-label="' +
        rev.rating +
        ' out of 5 stars">' +
        starString(rev.rating) +
        '</span>';
      if (rev.author) {
        html += '<span class="pdp-us-reviews__card-author">' + escapeHtml(rev.author);
        if (rev.location) {
          html += ' <span class="pdp-us-reviews__card-location">(' + escapeHtml(rev.location) + ')</span>';
        }
        html += '</span>';
      }
      html += '</div>';
      if (rev.title) {
        html += '<p class="pdp-us-reviews__card-title">' + escapeHtml(rev.title) + '</p>';
      }
      html += '<p class="pdp-us-reviews__card-body">' + escapeHtml(rev.body) + '</p>';
      html += '</li>';
    });
    html += '</ul>';
    return html;
  }

  async function fetchWidget(shop, token, productId) {
    var query =
      'shop_domain=' +
      encodeURIComponent(shop) +
      '&api_token=' +
      encodeURIComponent(token) +
      '&external_id=' +
      encodeURIComponent(productId);
    var bases = ['https://api.judge.me/api/v1/widgets/product_review', 'https://judge.me/api/v1/widgets/product_review'];
    var lastError = null;
    for (var i = 0; i < bases.length; i++) {
      try {
        var res = await fetch(bases[i] + '?' + query, { credentials: 'omit', mode: 'cors' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var data = await res.json();
        if (data && typeof data.widget === 'string' && data.widget.indexOf('jdgm-rev') !== -1) {
          return data.widget;
        }
        lastError = new Error('Empty widget');
      } catch (err) {
        lastError = err;
      }
    }
    throw lastError || new Error('Judge.me widget fetch failed');
  }

  async function mount(root) {
    if (!root || root.getAttribute('data-reviews-loaded') === '1') return;
    var mountEl = root.querySelector('[data-pdp-us-reviews-mount]');
    if (!mountEl) return;

    var productId = root.getAttribute('data-product-id') || '';
    var shop = root.getAttribute('data-shop-domain') || '';
    var token = root.getAttribute('data-reviews-token') || '';
    if (!productId || !shop || !token) {
      mountEl.hidden = true;
      return;
    }

    function apply(html) {
      var cards = renderCards(extractReviews(html));
      if (!cards) {
        mountEl.hidden = true;
        return;
      }
      mountEl.innerHTML = cards;
      mountEl.hidden = false;
      root.setAttribute('data-reviews-loaded', '1');
    }

    var cached = readCache(shop, productId);
    if (cached) {
      apply(cached);
      return;
    }

    try {
      var html = await fetchWidget(shop, token, productId);
      writeCache(shop, productId, html);
      apply(html);
    } catch (e) {
      mountEl.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll('[data-pdp-us-reviews]').forEach(function (root) {
      mount(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
